(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information-extension"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const productDetails = document.querySelector('.product-details');
    const productInformationExtensions = document.querySelectorAll('product-information-extension');

    productInformationExtensions.forEach((productInformationExtension) => {
      // Move all children to product-details
      while (productInformationExtension.firstChild) {
        productDetails.appendChild(productInformationExtension.firstChild);
      }
      // Remove the empty parent element
      productInformationExtension.remove();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
